export enum InterpretationMode {
    view,
    edit,
    erase
}